module.exports = __webpack_public_path__ + "media/images/illustration/undraw_select_house_qbag-88323e92e5dd64f5118faa3ba29ef0a6.svg";